import { useEffect, useRef } from "react";
import CircularProgress from "@mui/material/CircularProgress";

/**
 * Put at the end of a scrollable list: calls `onVisible` when it scrolls into
 * view, to load the next page. A new `onVisible` re-observes, so a list that
 * is still shorter than its container keeps loading until it fills it.
 */
export default function PiLoadMoreSentinel(props: {
  onVisible: () => void;
  isLoading?: boolean;
}) {
  const { onVisible, isLoading } = props;
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const element = ref.current;
    if (!element || typeof IntersectionObserver === "undefined") return;

    const observer = new IntersectionObserver((entries) => {
      if (entries.some((entry) => entry.isIntersecting)) onVisible();
    });
    observer.observe(element);
    return () => observer.disconnect();
  }, [onVisible]);

  return (
    <div
      ref={ref}
      data-testid="load-more-sentinel"
      className="flex w-full min-h-[1px] justify-center"
    >
      {isLoading && <CircularProgress size={16} className="my-[6px]" />}
    </div>
  );
}
